import type { DocumentListStore } from './contract';

const _registry = new Map<string, DocumentListStore>();

export const DocumentListStoreRegistry = {
  register(key: string, store: DocumentListStore): void {
    _registry.set(key, store);
  },
  get(key: string): DocumentListStore | undefined {
    return _registry.get(key);
  },
  forEach(fn: (registryKey: string, store: DocumentListStore) => void): void {
    _registry.forEach((store, registryKey) => fn(registryKey, store));
  },
};
